import {gql} from '@apollo/client';

export const editProfileQuery = gql`
  query EditProfileQuery($imageVariant: FileImageVariant!) {
    me {
      id
      avatar {
        id
        url(variant: $imageVariant, raw: false)
      }
      userProfile {
        email
        birthSex
        birthday
        firstName
        formattedBirthSex @client
        formattedBirthday @client
        formattedHeight @client
        formattedWeight @client
        formattedPhoneNumber @client
        phoneNumber
        height
        heightDisplayUnit
        id
        initials @client
        lastName
        pronouns
        weight
        weightDisplayUnit
      }
    }
  }
`;

export const updateUserProfileMutation = gql`
  mutation UpdateUserProfile($input: UpdateUserProfileInput!) {
    updateUserProfile(input: $input) {
      birthSex
      birthday
      firstName
      height
      heightDisplayUnit
      id
      lastName
      pronouns
      weight
      weightDisplayUnit
    }
  }
`;
